import { jsx as _jsx } from "react/jsx-runtime";
import PayoutStatistics from '../PayoutStatistics';
const PayoutCountryStatistics = (props) => (_jsx(PayoutStatistics, Object.assign({}, props, { className: "payout-country-statistics", label: "Teams", renderTitle: statistic => `Motty ${statistic.country}` })));
export default PayoutCountryStatistics;
